export const AllergyPill = {
  tag: 'span',
  text: (el, s) => s.label || 'Allergy',
  fontSize: 'Y',
  fontWeight: '600',
  padding: 'X Y',
  round: 'B',
  background: 'red.15',
  color: 'red'
}

export const PatientBanner = {
  flow: 'x',
  align: 'center flex-start',
  gap: 'Z',
  padding: 'Z A',
  background: 'inkSubtle',
  color: 'white',
  width: '100%',
  flexWrap: 'wrap',
  AvatarInitial: {
    text: (el, s) => s.name ? s.name.charAt(0) : '?',
    width: 'C',
    height: 'C',
    round: 'D',
    background: 'teal',
    color: 'white',
    fontWeight: '700',
    fontSize: 'A',
    flow: 'x',
    align: 'center center',
    flexShrink: '0'
  },
  PatientName: { text: (el, s) => s.name || 'Patient', fontSize: 'A', fontWeight: '700', color: 'white' },
  Age: { text: (el, s) => s.age ? s.age + ' yrs' : '', fontSize: 'Z', color: 'white.70' },
  Allergies: {
    if: (el, s) => !!s.allergies,
    flow: 'x',
    gap: 'X',
    flexWrap: 'wrap',
    childExtends: 'AllergyPill',
    childrenAs: 'state'
  },
  InsuranceBadge: {
    if: (el, s) => !!s.insurance,
    tag: 'span',
    text: (el, s) => s.insurance || '',
    fontSize: 'Y',
    fontWeight: '600',
    padding: 'X Z',
    round: 'B',
    background: 'blue.15',
    color: 'blue'
  },
  QuickStats: {
    flow: 'x',
    gap: 'Z',
    align: 'center center',
    marginLeft: 'auto',

    TotalProcedures: {
      flow: 'x',
      gap: 'X',
      align: 'center center',
      padding: 'X Z',
      round: 'B',
      background: 'teal.15',

      ProcIcon: {
        extends: 'Icon',
        icon: 'clipboard',
        fontSize: 'Y',
        color: 'teal'
      },

      ProcCount: {
        text: (el, s) => {
          var history = s.root && s.root.toothHistory ? s.root.toothHistory : {}
          var total = 0
          var keys = Object.keys(history)
          for (var i = 0; i < keys.length; i++) {
            total += history[keys[i]].length
          }
          return total + ' {{ procedures | polyglot }}'
        },
        fontSize: 'Y',
        fontWeight: '600',
        color: 'teal'
      }
    },

    NextAppointment: {
      flow: 'x',
      gap: 'X',
      align: 'center center',
      padding: 'X Z',
      round: 'B',
      background: 'blue.15',

      ApptIcon: {
        extends: 'Icon',
        icon: 'calendar',
        fontSize: 'Y',
        color: 'blue'
      },

      ApptText: {
        text: '{{ nextAppt | polyglot }}: Mar 25',
        fontSize: 'Y',
        fontWeight: '600',
        color: 'blue'
      }
    },

    LastVisit: {
      if: (el, s) => !!s.lastVisit,
      text: (el, s) => 'Last visit: ' + (s.lastVisit || ''),
      fontSize: 'Y',
      color: 'white.70'
    }
  }
}
